import { useEffect, useState } from "react";
import { cachedNames } from "utils/enduserUtils";
import { shortName } from "utils/matchmakerUtils";

export const UserName = ({ userId, hideName=false }) => {
  const [userName, setUserName] = useState("");
  const onUserNames = (event: any) => {
    const users = event.detail;
    const user = users?.find((u) => u.id === userId) || users?.find((u) => u.profileId === userId);
    if (user) {
      const name =
      (user?.firstName || "") + " " + (user?.lastName || "");
      if (hideName) {
        setUserName(shortName(name));
      } else {
        setUserName(name);
      }
    }
  };

  useEffect(() => {
    if (!userId) {
      setUserName("");
      return;
    }
    const user = cachedNames.find((u) => u.id === userId);
    if (user?.firstName) {
      setUserName((user?.firstName || "") + " " + (user?.lastName || ""));
    } else {
      document.addEventListener("userNames", onUserNames);
      return () => {
        document.removeEventListener("userNames", onUserNames);
      };
    }
  }, [userId]);

  return <div>{userName || "Loading Name..."}</div>;
};
